"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Encounter_StatusHistory = exports.Encounter_StatusHistoryStatusKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_Period_1 = require("./RTTI_Period");
var Encounter_StatusHistoryStatusKind;
(function (Encounter_StatusHistoryStatusKind) {
    Encounter_StatusHistoryStatusKind["_planned"] = "planned";
    Encounter_StatusHistoryStatusKind["_arrived"] = "arrived";
    Encounter_StatusHistoryStatusKind["_triaged"] = "triaged";
    Encounter_StatusHistoryStatusKind["_inProgress"] = "in-progress";
    Encounter_StatusHistoryStatusKind["_onleave"] = "onleave";
    Encounter_StatusHistoryStatusKind["_finished"] = "finished";
    Encounter_StatusHistoryStatusKind["_cancelled"] = "cancelled";
    Encounter_StatusHistoryStatusKind["_enteredInError"] = "entered-in-error";
    Encounter_StatusHistoryStatusKind["_unknown"] = "unknown";
})(Encounter_StatusHistoryStatusKind = exports.Encounter_StatusHistoryStatusKind || (exports.Encounter_StatusHistoryStatusKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_Encounter_StatusHistory = t.recursion('IEncounter_StatusHistory', function () {
    return t.intersection([
        t.type({
            period: RTTI_Period_1.RTTI_Period
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            status: (0, EnumType_1.createEnumType)(Encounter_StatusHistoryStatusKind, 'Encounter_StatusHistoryStatusKind'),
            _status: RTTI_Element_1.RTTI_Element
        })
    ]);
});
//# sourceMappingURL=RTTI_Encounter_StatusHistory.js.map